import { SearchEntry, SearchMatch } from "./GlobalSearch.Types";

/** Case-insensitive substring match against title, then the wider snippet text. */
export function matchEntries(entries: SearchEntry[], query: string): SearchMatch[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];

  const matches: SearchMatch[] = [];
  for (const entry of entries) {
    const titleMatch = entry.title.toLowerCase().includes(q);
    if (titleMatch || entry.matchText.includes(q)) {
      matches.push({ entry, titleMatch });
    }
  }
  return matches;
}
